import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomePageButton = ({ style }) => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/home');
    };

    return (
        <button
            onClick={handleGoHome}
            className="home-page-button"
            style={style}
        >
            Przejdź do Strony Głównej
        </button>
    );
};

export default HomePageButton;